import { IMAGE_BASE_URL } from '@/utils/constent';
import React, { ImgHTMLAttributes, useEffect, useState } from 'react';
interface AppImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  fallbackSrc?: string;
}
const Images: React.FC<AppImageProps> = ({
  src,
  alt,
  fallbackSrc = '/download.webp',
  className = '',
  ...props
}) => {
  const getImageSrc = (value: string) => {
    if (!value) return fallbackSrc;

    if (value.startsWith('http') || value.startsWith('blob:') || value.startsWith('data:')) {
      return value;
    }

    return `${IMAGE_BASE_URL}${value}`;
  };
  const [imgSrc, setImgSrc] = useState<string>(() => getImageSrc(src));
  const fallbackImage = getImageSrc(fallbackSrc);
  // update only when src changes
  useEffect(() => {
    setImgSrc(src ? getImageSrc(src) : fallbackImage);
  }, [src, fallbackImage]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => {
        if (imgSrc !== fallbackImage) {
          setImgSrc(fallbackImage);
        }
      }}
      {...props}
    />
  );
};

export default Images;
